import resaleAgreements from "./resale-agreements"
import timeline from "./timeline"
import types from "./types"
import revisions from "./revisions"
import enedisContractSubscriptionTypes from "./enedis-contract-subscription-types"
import requiredFields from "./required-fields"
import mandate from "./mandates"
import solarPanelTiltForm from "./solar-panel-tilt-form"
import statistics from "./statistics"

export default {
  "resale-agreements": resaleAgreements,
  "required-fields": requiredFields,
  mandate: mandate,
  "solar-panel-tilt-form": solarPanelTiltForm,
  revisions,
  statistics,
  timeline,
  types,
  "enedis-contract-subscription-types": enedisContractSubscriptionTypes,
  mayor: {
    contactCard: {
      website: "Site web",
      plans: "Plans",
      phone: "Telephone du standard",
      email: "Email du standard",
      "urban-planning-phone": "Telephone du service d'urbanisme",
      "urban-planning-email": "Email du service d'urbanisme",
    },
  },
  services: {
    ALL: "Tous les dossiers",
    CONSUEL: "Visa Consuel (pour habitation)",
    CONSUEL_LARGE_PRODUCER: "Visa Consuel (pour commercial)",
    MAYOR: "Autorisation d'urbanisme (pour habitation)",
    MAYOR_LARGE_PRODUCER: "Autorisation d'urbanisme (pour commercial)",
    GRID_CONNECTION: "Raccordements (< 36kVA)",
    GRID_CONNECTION_LARGE_PRODUCER: "Raccordements (36-250kVA)",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA:
      "Raccordements (250-500kVA)",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA: "Raccordements (>500kVA)",
    RESALE_AGREEMENT: "Contrats d’achat",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA:
      "Raccordements (250-500kVA)",
    GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA: "Raccordements (>500kVA)",
    LARGE_PRODUCER_FOR_HOUSING: "Pour habitation",
    LARGE_PRODUCER_FOR_COMMERCIAL: "Pour commercial",
  },
}
